"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var _default = exports["default"] = (0, _reactIntl.defineMessages)({
  ariaLabelNavigation: {
    id: 'components.AppBarMobile.ariaLabelNavigation',
    defaultMessage: 'QuintoAndar Navigation Mobile'
  }
});